import './ProductsTab.scss';
import { PiChartLineUpBold } from 'react-icons/pi';
import InvestifyTab from '../WalletsTab/Wallets/Investify';
import GetItTab from './GetItTab/GetItTab';
import IpoTab from './IpoTab/IpoTab';
import InvestifyWT from '../../../../assets/icons/InvestifyWT.svg';
import InvestifyWTAC from '../../../../assets/icons/InvestifyWTAC.svg';
import getItLogo from '../../../../assets/images/getItLogo.svg';
import InactiveGetItLogo from '../../../../assets/images/InactiveGetItLogo.svg';
import { ProductsTabProps } from '../../../../types';

const ProductsTab = ({ activeSubTab, setActiveSubTab }: ProductsTabProps) => {
  const subTabs = [
    {
      key: 'investify',
      label: 'Investify',
      icon: (
        <img
          src={activeSubTab === 'investify' ? InvestifyWTAC : InvestifyWT}
          alt="Investify"
          style={{ width: '17px', height: '17px' }}
        />
      ),
      color: '#6624CE',
      bgColor: '#F3EBFF',
    },
    {
      key: 'getit',
      label: 'GetIt',
      icon: (
        <img
          src={activeSubTab === 'getit' ? getItLogo : InactiveGetItLogo}
          alt="GetIt"
          style={{ width: '17px', height: '17px', marginTop: '2px' }}
        />
      ),
      color: '#F37932',
      bgColor: '#FFF2EA',
    },
    {
      key: 'ipo',
      label: 'IPO Investment',
      icon: <PiChartLineUpBold size={17} />,
      color: '#6624CE',
      bgColor: '#F3EBFF',
    },
  ];

  return (
    <div className="products-tab">
      <div className="customer-page-tab-nav flex--2 pointer">
        {subTabs.map((tab) => (
          <div
            key={tab.key}
            className={`link flex--2 ${activeSubTab === tab.key ? 'active' : ''}`}
            style={{
              backgroundColor: activeSubTab === tab.key ? tab.bgColor : 'transparent',
              color: activeSubTab === tab.key ? tab.color : '#4B5563',
              borderColor: activeSubTab === tab.key ? 'transparent' : '#B8B8B8',
            }}
            onClick={() => setActiveSubTab(tab.key)}
          >
            <span className="icon flex--2" style={{ color: activeSubTab === tab.key ? tab.color : '#5F5F5F' }}>
              {tab.icon}
            </span>
            <span className="label">{tab.label}</span>
          </div>
        ))}
      </div>

      <div className="products-content">
        {activeSubTab === 'investify' && <InvestifyTab />}
        {activeSubTab === 'getit' && <GetItTab />}
        {activeSubTab === 'ipo' && <IpoTab />}
      </div>
    </div>
  );
};

export default ProductsTab;
